import React from 'react';

// DL.13 - Υποβολή παραπόνων/θετικών σχολίων
const DL13 = ({ formData, updateFormData }) => {
  const handleChange = (e) => {
    updateFormData({ [e.target.name]: e.target.value });
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 15) {
      updateFormData({ phone: value });
    }
  };

  return (
    <div>
      <div className="alert alert-info" style={{ marginBottom: '20px' }}>
        <p style={{ margin: 0 }}>
          <strong>Οδηγία:</strong> Παρακαλούμε γράψτε τα σχόλιά σας στο παρακάτω πλαίσιο:
        </p>
      </div>

      <div className="form-group">
        <label htmlFor="comments">
          Σχόλια / Παράπονα / Θετικά Σχόλια <span className="required">*</span>
        </label>
        <textarea
          id="comments"
          name="comments"
          value={formData.comments || ''}
          onChange={handleChange}
          placeholder="Περιγράψτε τα σχόλια ή τα παράπονά σας..."
          rows="8"
          required
          style={{ width: '100%' }}
        />
        <small style={{ color: '#666', display: 'block', marginTop: '5px' }}>
          Παρακαλούμε να είστε όσο πιο συγκεκριμένοι γίνεται
        </small>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="email">
            Email <span className="required">*</span>
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email || ''}
            onChange={handleChange}
            placeholder="example@email.com"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="phone">
            Τηλ. Επικοινωνίας <span className="required">*</span>
          </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone || ''}
            onChange={handlePhoneChange}
            placeholder="2101234567"
            inputMode="numeric"
            pattern="\d{10,15}"
            title="Εισάγετε μόνο αριθμούς (10-15 ψηφία)"
            required
          />
        </div>
      </div>
    </div>
  );
};

export default DL13;








